/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Cta_DownloadInputs */

const en_vc_cta_download = /** @type {(inputs: Vc_Cta_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download VectorCraft`)
};

const zh_vc_cta_download = /** @type {(inputs: Vc_Cta_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 VectorCraft`)
};

/**
* | output |
* | --- |
* | "Download VectorCraft" |
*
* @param {Vc_Cta_DownloadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_cta_download = /** @type {((inputs?: Vc_Cta_DownloadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Cta_DownloadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_cta_download(inputs)
	return zh_vc_cta_download(inputs)
});
export { vc_cta_download as "vc.cta.download" }